<template>
    <div class="bar-container" :class="{ 'show-menu': showMenu }">
        <div class="menu">
            <img class="logo" :src="require('@/assets/nav/logo.svg')" :style="{ opacity: alpha }" alt="" />
            <div class="hamburger" @click="showMenu = !showMenu"></div>
        </div>
        <div class="menu-list" v-if="alpha !== 1 || (alpha === 1 && showMenu)">
            <div
                class="nav-item"
                v-for="(nav, index) in navList"
                :key="nav.route + index"
                :class="{
                    'active':
                        (nav.route === $route.path && nav.route !== '/') || (nav.src && alpha >= 0.05 && alpha !== 0.99) || (alpha < 0.05 && nav.route === '/')
                }"
                @click="jump(nav)"
            >
                <div class="title">
                    {{ $t(nav.title) }}
                    <span  v-if="nav.src" class="fire-title" :class="{ 'fire-active': alpha > 0.05 && $route.path === '/' }">MicAI</span>
                    <!-- <img class="fire" v-if="nav.src" :src="alpha > 0.05 && $route.path === '/' ? nav.activeSrc : nav.src" alt="" /> -->
                </div>
            </div>
            <lang-box class="lang-container" />
        </div>
    </div>
</template>

<script>
import LangBox from './LangBox.vue'
export default {
    components: { LangBox },
    props: ['alpha', 'isMobile'],
    data() {
        return {
            navList: [
                {
                    title: 'nav.home',
                    route: '/'
                },
                {
                    title: '',
                    route: '/fire',
                    src: require('@/assets/nav/logo-white.svg'),
                    activeSrc: require('@/assets/nav/logo-blue.svg')
                },
                {
                    title: 'nav.about',
                    route: '/about'
                },
                // {
                //     title: 'nav.awards',
                //     route: '/awards'
                // },
                // {
                //     title: 'nav.duty',
                //     route: '/duty'
                // },
                {
                    title: 'nav.blog',
                    route: '/blog'
                },
                {
                    title: 'nav.fund',
                    route: '/fund'
                },
                {
                    title: 'nav.history',
                    route: '/history'
                }
            ],
            showMenu: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            this.showMenu = false
        },
        jump(nav) {
            if (this.$route.path === nav.route) {
                window.scrollTo(0, 0)
                this.$emit('toTop')
                this.showMenu = false
                return
            }
            if (nav.src) {
                if (this.$route.path !== '/') {
                    this.$router.push('/')
                }
                this.$emit('toFire')
                this.showMenu = false
            } else {
                this.showMenu = false
                this.$router.push(nav.route)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.bar-container {
    height: 100vh;
    padding-top: 200px;
    position: relative;
    .nav-item {
        border-left: 3px solid transparent;
        border-right: 2px solid transparent;
        color: #fff;
        display: block;
        font-size: 14px;
        font-weight: 600;
        min-height: 54px;
        padding-right: 5px;
        position: relative;
        transition: 0.5s;
        width: 120px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .nav-item.active,
    .nav-item:hover {
        border-left: 3px solid var(--active-color);
        color: var(--active-color);
    }
}
.more-icon {
    display: none;
}
.logo {
    cursor: pointer;
    left: 50%;
    position: absolute;
    top: 60px;
    transform: translateX(-50%);
    transition: 0.5s;
    width: 45px;
    transition: transform 0.5;
    &:hover {
        transform: translateX(-50%) rotate(180deg);
    }
}
.fire {
    width: 38px;
}
.title {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.fire-title{
    font-size: 32px;
    font-weight: bold;
    color: #fff;
}
.fire-active{
    color: var(--active-color);
}
.lang-container {
    display: none;
}
@media screen and (max-width: 768px) {
    .lang-container {
        display: block;
        text-align: center;
        margin-top: 50px;
        /deep/.lang {
            font-size: 13px;
        }
    }
    .bar-container {
        padding-top: 0;
        width: 100vw;
        height: auto;
        .nav-item {
            width: 100%;
            border-top: 0.3px solid #86868b;
            font-size: 12px;
            height: 48px;
            line-height: 48px;
            margin: auto;
            padding-left: 0;
            padding-right: 0;
            text-align: center;
            &:first-child {
                border-top: none;
            }
        }
        .nav-item.active,
        .nav-item:hover {
            border-left: none;
        }
    }
    .menu-list {
        padding: 0 15px;
    }
    .menu {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        background: rgba(31, 29, 30, 0.7);
    }
    .logo {
        position: unset;
        transform: none;
        height: 30px;
    }
    .hamburger {
        background-color: transparent;
        border-radius: 6%;
        cursor: pointer;
        height: 100%;
        width: 36px;
        display: block;
        height: var(--mobile-nav-height);
        width: 40px;
        right: 15px;
    }
    .hamburger,
    .hamburger:after,
    .hamburger:before {
        background: #fff;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        content: '';
        height: 2.16px;
        position: absolute;
        transition: 0.3s;
        width: 23.76px;
    }
    .hamburger:before {
        top: -7.92px;
    }
    .hamburger:after {
        top: 7.92px;
    }
    .show-menu {
        background: #2e55a5;
        opacity: 1;
        transform: translateY(0);
        height: 100vh;
        .menu {
            background: #2e55a5;
        }
        .hamburger {
            height: 0;
        }
        .hamburger:after {
            top: 0;
            transform: rotate(-45deg);
        }
        .hamburger:before {
            top: 0;
            transform: rotate(45deg);
        }
    }
}
</style>
